import { Fragment, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router";

import { Table, Icon, Alert, NotificationManager } from "design-react-kit";

import "../../assets/Table.css";
import TableSearch from "./TableSearch";
import TableHeader from "./TableHeader";
import UserContext from "../../store/user-context";
import { useSignIn, useSignOut } from "react-auth-kit";
import FlowHistoryModal from "../Modals/FlowHistoryModal";
import {
  filterHandler,
  showFlowType,
  showStatus,
} from "../../services/helpers";
import { sendApiRequest } from "../../services/Base/base-service";
import PaginationControls from "../PaginationControls";

const AuthModuleArchiveTable = ({
  items,
  columns,
  getFlows,
  filters,
  totalCount,
  currentPage,
  pageSize,
  pageSizeOptions,
  onPageChange,
  onPageSizeChange,
}) => {
  const [results, setResults] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [historyData, setHistoryData] = useState(null);
  const [selectedFlowName, setSelectedFlowName] = useState(null);
  const [selectedFlowClientCode, setSelectedFlowClientCode] = useState(null);
  const [modalError, setModalError] = useState(null);

  const userContext = useContext(UserContext);

  const signIn = useSignIn();
  const signOut = useSignOut();
  const navigate = useNavigate();

  useEffect(() => {
    setResults(items);
  }, [items]);

  const modalOpenHandler = (flow) => {
    setModalOpen(true);
    setModalError(null);
    sendApiRequest(
      `StagedFlow/GetStagedFlowStatusesHistory?StagedFlowId=${flow.id}`,
      "GET",
      true,
      null,
      signIn,
      signOut,
      navigate,
      null,
      userContext
    ).then((response) => {
      if (response !== undefined) {
        if (response.errors !== null) {
          setModalError(response.errors);
          setTimeout(() => {
            document
              .querySelector("#table-modal .modal-content")
              .classList.add("scale");
          }, 200);
        } else {
          setSelectedFlowName(flow.name);
          setSelectedFlowClientCode(flow.clientCodeName);
          setHistoryData(response.data);
          setTimeout(() => {
            document
              .querySelector("#table-modal .modal-content")
              .classList.add("scale");
          }, 200);
        }
      }
    });
  };

  const modalCloseHandler = () => {
    document
      .querySelector("#table-modal .modal-content")
      .classList.remove("scale");
    setTimeout(() => {
      setModalOpen(false);
    }, 600);
  };

  return (
    <Fragment>
      <div className="d-flex flex-column align-items-stretch justify-content-start w-100 archive-table-wrapper">
        <div className="d-flex align-items-start justify-content-end w-100">
          <TableSearch
            items={items}
            filterHandler={filterHandler}
            setResults={setResults}
            text={"Cerca per nome del flusso"}
            column={"name"}
          />
          <span title="Aggiornare i dati della tabella">
            <Icon
              icon="it-refresh"
              fill="#06c"
              className="ml-3 mt-1 mb-2"
              type="button"
              onClick={(e) => getFlows(filters)}
            />
          </span>
        </div>
        <Table responsive className="table">
          <TableHeader
            columns={columns}
            setResults={setResults}
            items={items}
          />
          <tbody>
            {results !== null &&
              results !== undefined &&
              results.map((result) => {
                return (
                  <tr key={result.id}>
                    <td className="modifiedOn">
                      {result.modifiedOn === null
                        ? result.predispositionDate
                        : result.modifiedOn}
                    </td>
                    <td className="predispositionDate">
                      {result.predispositionDate}
                    </td>
                    <td className="name">{result.name}</td>
                    <td className="clientName">{result.clientCodeName}</td>
                    <td className="flowType">
                      {showFlowType(result.flowType)}
                    </td>
                    <td className="notificationsCount text-center">
                      {result.countAnNotifications +
                        result.countDigNotifications}
                    </td>
                    <td className="status text-center">{showStatus(result)}</td>
                    <td
                      className="text-center edit-invalid-notification"
                      title="Cronologia stati"
                    >
                      <Icon
                        icon="it-password-visible"
                        fill="#06c"
                        role="button"
                        onClick={(e) => modalOpenHandler(result)}
                      />
                    </td>
                  </tr>
                );
              })}
            {results !== null && results.length === 0 && (
              <tr>
                <td colSpan={12}>
                  <Alert className="w-50 mx-auto" color="info">
                    Nessun risultato trovato!
                  </Alert>
                </td>
              </tr>
            )}
          </tbody>
        </Table>
        <PaginationControls
          totalCount={totalCount}
          currentPage={currentPage}
          pageSize={pageSize}
          pageSizeOptions={pageSizeOptions}
          onPageChange={onPageChange}
          onPageSizeChange={onPageSizeChange}
        />
      </div>
      {(historyData !== null || modalError !== null) && (
        <FlowHistoryModal
          modalOpen={modalOpen}
          modalCloseHandler={modalCloseHandler}
          historyData={historyData}
          showStatus={showStatus}
          error={modalError}
          page="stagedArchive"
          flowName={selectedFlowName}
          clientCodeName={selectedFlowClientCode}
        />
      )}
      <div>
        <NotificationManager
          containerId="table-user-message"
          fix="right"
          closeOnClick={true}
          state="success"
          duration={30000}
        />
      </div>
    </Fragment>
  );
};

export default AuthModuleArchiveTable;
